import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withTranslation } from 'react-i18next';

function Filters(props) {
  return (
    <Grid item xs={12}>
      <Card className={props.classes.root}>
        <CardHeader title={props.t('Filter')} />
        <CardContent>
          <Grid container spacing={3} className={props.classes.container}>
            <Grid container item xs={4}>
              <TextField
                fullWidth
                id="taxNumber"
                label={props.t('identifier.taxNumber')}
                value={props.filter.taxNumber}
                onChange={props.onFilterChange}
              />
            </Grid>
            <Grid container item xs={4}>
              <TextField
                fullWidth
                id="name"
                label={props.t('Name')}
                value={props.filter.name}
                onChange={props.onFilterChange}
              />
            </Grid>
            <Grid container item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="unit-label">{props.t('Contractor')}</InputLabel>
                <Select
                  labelId="unit-label"
                  fullWidth
                  value={props.filter.subcontracted}
                  onChange={props.onFilterChange}>
                  <MenuItem id="subcontracted" value="">
                    {props.t('All')}
                  </MenuItem>
                  <MenuItem id="subcontracted" value>
                    {props.t('Contractors')}
                  </MenuItem>
                  <MenuItem id="subcontracted" value={false}>
                    {props.t('Company')}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default withTranslation()(Filters);
